<template>
  <div>
    <van-popup
      class="full-width full-height"
      v-model="isShow"
      position="right"
      :close-on-popstate="true"
    >
      <div>
        <ld-header @click-left="toggle">
          {{ title }}
        </ld-header>
        <div
          v-for="(info,index) in orderlist"
          :key="index"
        >
          <van-cell>{{ info.terminalName }}</van-cell>
          <van-cell
            v-for="(tel,index2) in info.linkTel.split('#').length"
            :key="index2"
          >
            {{ info.linkTel.split('#')[index2] }}
          </van-cell>
        </div>
      </div>
      <ld-no-more />
    </van-popup>
  </div>
</template>
<script>
import {Popup ,Cell } from 'vant'
import ldHeader from 'Common/ldHeader'
import ldNoMore from 'Common/ldNoMore'

export default {
  name:'Taxi',
  data() {
    return {
      isShow:false,
      isShowBus:false,
      isShowSubway:false,
      active: '1', //   1 大巴 2 地铁
      orderlist: [],
      parkDetail: '',
      id:'',
    }
  },
  components:{
    [Popup.name]:Popup,
    [Cell.name]:Cell,
    ldHeader,
    ldNoMore
  },
  props:{
    title:{
      type:String,
      default:''
    },
    threeCode:{//三字码
      type:String,
      default:''
    },
    terminal:{//航站楼
      type:String,
      default:'T1'
    }
  },
  computed:{
  },
  methods:{
    init(){
      this.getCarList()
    },
    getCarList() {
      this.$api['tkStrategy/queryApTrnInfo']({
        threeCode: this.threeCode,
        terminal: this.terminal,
      }).then(resp=>{
        var respose = resp.data||{}
        this.orderlist = respose
      })
    },
    toggle(){
      this.isShow=!this.isShow
      if(this.isShow){
        this.init()
      }
    },
  },
}
</script>
<style lang="less" scoped>
    .pad-lr-16{
        padding:0 16px;
    }
</style>